<template>
  <div class="page-content">

    <page-template
      ref="deposit"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    >
    </page-template>
  </div>
</template>

<script>
  import api from "@/config/api";
  import pageTemplate from "@/components/template/pageTemplate";
  import userPower from "@/mixin/userPower";

  export default {
    mixins: [userPower],
    components: {pageTemplate},
    data() {
      return {
        indexShow: false,
        // 更多功能
        toolConfig: [
          {
            label: '导出',
            code: 'export',
            callback: this.export,
          },
        ],
        searchOptions: {
          simple: [
            {
              label: '会员姓名/手机号/卡号',
              prop: 'memberName',
              type: 'input',
              span: 24,
              placeholder: "请输入会员姓名/手机号/卡号",
            },
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            // {
            //   label: '会员ID',
            //   prop: 'memberId',
            //   type: 'input',
            //   span: 8,
            // },
            {
              label: "会员手机号",
              prop: "memberPhone",
              type: "input",
              span: 8,
            },
            {
              label: "会员类别",
              prop: "memberCategoryId",
              type: "select",
              span: 8,
              data: [],
              url: api.member.category,
            },
            {
              label: "消费门店",
              prop: "consumeStoreId",
              type: "select",
              span: 8,
              data: [],
              isHasAll:true,
              url: api.system.seStore,
            },
            {
              label: "发卡门店",
              prop: "cardStoreId",
              type: "select",
              span: 8,
              data: [],
              isHasAll:true,
              url: api.system.seStore,
            },
          ],
        },
        tableOptions: {
          showSummary: true,
          summaryColumns: ['allMoney'],
          indexShow: true, //是否显示索引
          columns: [
            {
              label: "消费单号",
              prop: "billOrderNo",
              align: "center",
              width: "190"
            },
            {
              label: "消费分店",
              prop: "consumeStoreName",
              align: "center",
              width: "160"
            },
            {
              label: "付款金额",
              prop: "allMoney",
              align: "center",
              width: "90",
            },
            {
              label: "余额",
              prop: "balance",
              align: "center",
              width: "90",
            },
            {
              label: "消费时间",
              prop: "lastModifyDttm",
              align: "center",
              width: "190"
            },
            {
              label: "发卡门店",
              prop: "cardStoreName",
              align: "center",
              width: "120"
            },
            {
              label: "会员手机号",
              prop: "memberPhone",
              width: "120",
              span: 8,
            },
            {
              label: "姓名",
              prop: "memberName",
              align: "center",
              width: "90"
            },
            {
              label: "会员卡号",
              prop: "memberCardNum",
              align: "center",
              width: "120"
            },
            {
              label: "会员类别",
              prop: "memberCategoryName",
              align: "center",
              width: "90"
            },
            {
              label: "备注",
              prop: "remarks",
              align: "center",
              width: "90"
            },
          ],
          url: api.member.consumeRecord
        },
      };
    },
    created() {
      this.storeChange()
    },
    mounted() {
    },
    methods: {
      //如果是门店登录的时候目标门店是不可编辑的
      storeChange() {
        let user = this.$utils.getSysUser();
        // if (user.type === 20) {
        // this.searchOptions.complex.filter(item => item.prop === 'consumeStoreId')[0].disabled = true;
        // this.$nextTick(() => {
        //   this.$refs['searchFormTemp'].formModel.consumeStoreId = user.storeId;
        // })
        // }
      },
      export() {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        let param = this.$refs["deposit"].getCurrentParams();
        this.$axios.PostBlob(api.member.consumeRecordExport, param).then(res => {
          if (res.status === 200) {
            const fileName = '会员储值消费明细_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            // this.$message.success("导出成功,文件名称:" + fileName);
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      }
    },
  };
</script>

<style scoped>
.page-template{
  padding-top:0;
}
  .page-template .centerBack {
    background: #fff;
    border-radius: 8px;
    padding: 25px;
  }

  .page-template .echartsArea {
    height: 270px;
    margin-bottom: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/page/member/recharge/consumeRecord.vue